<template>
  <div class="not-found">
    <navbar v-if="account"/>
    <div id="scroll" class="lower-page" v-else>
      <header class="gnav non-login">
        <h1>
          <router-link :to="{ name: 'Home', params: { lang: activeLanguage } }">
            <img src="@/assets/img/client/logo.png" alt="GLOCALY MEMBERS SITE">
          </router-link>
        </h1>
      </header>
    </div>
    <div class="lower-mv" :style="lowermv">
      <h2 v-html="$t('Not Found')"></h2>
    </div>
    <section class="wrapper">
      <p class="txt" v-html="$t('404 Not Found')"></p>
        <p class="topLink">
          <router-link :to="{ name: 'Home', params: { lang: activeLanguage } }" class="brown_btn"><span>TOP</span></router-link>
        </p>
    </section>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import Vue from 'vue'

export default {
  data () {
    return {
      language: this.$route.params.lang,
      currentlanguage: Vue.$cookies.get('language'),
      account: Vue.$cookies.get('account'),
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      }
    }
  },
  components: {
    navbar,
    footerClient
  },
  computed: {
    activeLanguage () {
      if (!this.language && !this.currentlanguage) {
        return 'ja'
      } else {
        if (!this.language) {
          return this.currentlanguage
        }
        return this.language
      }
    }
  }
}
</script>
